import React, { useEffect, useState, Fragment } from "react";
import { Card, Form, Modal } from "react-bootstrap";
import { BsArrowBarDown, BsChevronDown, BsChevronUp } from "react-icons/bs";
import Layout from "../../components/Layout";
import LanguageContext from "../../helper/LanguageContext";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import { Link, useHistory } from "react-router-dom";
import LocationSearchInput from "../../components/LocationSearchInput";
import { callAPI } from "../../helper/apiUtils";
import { $crud } from "../../helper/CrudFactory";
import CompanyListDialog from "./Dialogs/CompanyListDialog";
import ProjectMapComponent from "./ProjectMap/ProjectMapComponent";
import _ from "lodash";
import AutoComplete from "./Partial/AutoComplete";
import { Animated } from "react-animated-css";
import { store, UPDATE_PROJECT_ACTION_FIRE } from "../../store";
import Geocode from "react-geocode";
import { withRouter } from "react-router-dom";
import { KJUUP_COLORS, TOGGLE_DRAWER } from "../../helper/constants";
import { connect, useDispatch, useSelector } from "react-redux";
import { BiArrowToBottom } from "react-icons/bi";
import ModernToggleSwitch from "../../components/ModernToggleSwitch";
import "./AddProject.css";
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_KEY;

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_KEY);
function AddProject(props) {
  const isInternal = props.isInternal
  const [params, setParams] = useState({
    companyId: "",
    name: "",
    projectNo: "",
    buildingType: [],
    areaOfActivity: "",
    street: "",
    postCode: "",
    city: "",
    country: "",
    lat: "",
    long: "",
    companyName: "",
    houseNo: "",
    isHidden: true,
    full_address: ""
  });
  const [selectedAddress, setSelectedAddress] = useState(false)
  const [loading, setLoading] = useState(false);
  const [displayTypes, setDisplayTypes] = useState('');
  const [errors, setErrors] = useState({
    companyId: "",
    name: "",
    projectNo: "",
    buildingType: "",
    areaOfActivity: "",
    street: "",
    // postCode: "",
    city: "",
    country: "",
    lat: "",
    long: "",
    houseNo: "",
  });
  const [cameraModal, setCameraModal] = useState(false);
  const [street, setStreet] = useState('');
  const [house, setHouse] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [city, setCity] = useState('');
  const [pNo, setPNo] = useState('');
  const [email, setEmail] = useState('');
  const [lat, setLat] = useState();
  const [long, setLong] = useState();
  const [full_address, setFullAddress] = useState('');
  const [countryName, setCountryName] = useState('');
  const [pid, setPid] = useState('');
  const [showDropdpownCity, setShowDropdpownCity] = useState(false)
  const [citySelected, setCitySelected] = useState([]);
  const [citySelectedAPIParam, setCitySelectedAPIParam] = useState([]);
  const [searchCity, setSearchCity] = useState('');
  const [showOptionalInfo, setShowOptionalInfo] = useState(true)
  const [paramsLoaded, setParamsLoaded] = useState({
    name: false,
    buildingType: false,
    areaOfActivity: false,
    projectNo: false,
  });
  const { isGerm, strings } = React.useContext(LanguageContext);
  const [suggestionLoaded, setSuggestionLoaded] = useState(false);
  const [show, setShow] = useState(false);
  const [showCompanyDialog, setCompanyDialog] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showOptionalInformation, setShowOptionalnformation] = useState(false)
  const [disableAll, setDisableAll] = useState(false)
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const dispatch = useDispatch()
  const getList = async () => {
    try {
      const { data } = await callAPI(`/building/all?projectType=${isInternal ? "1" : "0"}`, "", "GET");
      console.log(data);
      if (data.status) {
        setSuggestions(!isInternal ? data.buildings : []);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const setParam = (name, value) => {
    console.log(name, value)
    setParams((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    setErrors((prev) => {
      return {
        ...prev,
        [name]: "",
      };
    });
  };
  const setName = (name, value) => {
    if (value) {
      setParams((prev) => {
        return {
          ...prev,
          [name]: value,
        };
      });
      setErrors((prev) => {
        return {
          ...prev,
          [name]: "",
        };
      });
    }
  };
  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    //Role
    if (companies.length > 1) {
      if (!params.companyId) {
        formIsValid = false;
        errors["companyId"] = strings.invalid_fiels;
      }
    }
    //Firstname
    if (!params.name) {
      formIsValid = false;
      errors["name"] = strings.invalid_fiels;
    }

    // if (!params.areaOfActivity) {
    //   formIsValid = false;
    //   errors["areaOfActivity"] = strings.invalid_fiels;
    // }

    setErrors(errors);
    return formIsValid;
  };
  const history = useHistory();
  const [companies, setCompanies] = useState([]);
  const [companiesLoading, setCompaniesLoading] = useState(true);
  const [buildings, setBuildings] = useState([]);
  const getCompanies = async () => {
    setCompaniesLoading(true);
    try {
      const { data } = await callAPI(`/company/my`, {}, "GET");
      if (data.status) {
        if (data.companies.length === 1) {
          setParam("companyId", data.companies[0].id);
          setParam("companyName", data.companies[0].name);
        }
        setCompanies(data.companies);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setCompaniesLoading(false);
    }
  };
  useEffect(() => {
    setParam('buildingType', '')
    setDisplayTypes('')
    getCompanies();
    getBuildings();
    getList();
  }, [props.location]);
  const submitProject = async () => {
    setLoading(true);
    if (isInternal) {
      let errors = {}
      if (!params.name) {
        errors["name"] = strings.invalid_fiels;
        setErrors(errors)
      }
      else {
        setErrors(errors)
        try {
          let params1 = props.data
          let projectData = {
            "name": params.name,
            "projectNo": params.projectNo,
            "companyName": params1.companyName
          };
          if (params1.companyId) {
            projectData['companyId'] = params1.companyId
          }
          if (pid) {
            projectData['id'] = pid
          }
          console.log(projectData)
          const { data } = await callAPI("/building/createInternalBuilding", "", "POST", projectData);
          if (!data.status) {
            await $crud.notify({
              type: "error",
              message: data.message,
            });
          } else {
            store.dispatch({
              type: UPDATE_PROJECT_ACTION_FIRE,
              updateProjectActionFire: true,
            });
            props.closePage()
            dispatch({ type: TOGGLE_DRAWER, open: false });
          }
        } catch (e) {
          console.log(e);
        }
        setLoading(false);
      }
    }
    else if (handleValidation()) {
      if (pid) {
        params['id'] = pid
      }
      if (params.companyId) {
        params.companyId = params.companyId
      }
      else
        delete params.companyId
      try {
        const { data } = await callAPI(`/building`, "", "POST", params);
        if (!data.status) {
          await $crud.notify({
            type: "error",
            message: data.message,
          });
        } else {
          store.dispatch({
            type: UPDATE_PROJECT_ACTION_FIRE,
            updateProjectActionFire: true,
          });
          props.closePage()
          dispatch({ type: TOGGLE_DRAWER, open: false });
        }
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    } else {
      console.log("errors", errors);
    }
  };

  useEffect(() => {
    if (!selectedAddress) {
      let fullAddress = `${params.street} ${params.city ? `, ${params.city}` : ""}`
      console.log("fullAddress", fullAddress)
      Geocode.fromAddress(fullAddress).then(
        (results) => {
          const { lat, lng } = results.results[0].geometry.location;
          let country;
          for (var i = 0; i < results.results[0].address_components.length; i++) {
            for (
              var j = 0;
              j < results.results[0].address_components[i].types.length;
              j++
            ) {
              if (
                results.results[0].address_components[i].types[j] == "country"
              ) {
                country = results.results[0].address_components[i]?.long_name;
              }
            }
          }
          console.log("country", country)
          setParam('lat', lat)
          setParam('long', lng)
          setParam('country', country)
        },
        (error) => {
          console.error(error);
        }
      );
    }
    console.log("params", params.city, "street", params.street, "selectedAddress", selectedAddress)
  }, [params.city, params.street])

  const getSuggestion = async (suggestion) => {
    setDisableAll(true)
    let add = `${suggestion.houseNo ? suggestion.houseNo + ", " : ""}${suggestion.street ? suggestion.street + ", " : ''}${suggestion.city ? suggestion.city + ", " : ""}${suggestion.postCode ? suggestion.postCode + ", " : ""}${suggestion.country ? suggestion.country : ''}`
    console.log('---ad', add)
    setSearchCity(suggestion.full_address ? suggestion.full_address : add)
    setFullAddress(suggestion.full_address ? suggestion.full_address : add)
    setPid(suggestion.id)
    await setParams((prev) => {
      return {
        ...prev,
        name: suggestion.name ? suggestion.name : "",
        buildingType: true,
        areaOfActivity: suggestion.buildingType
          ? _.isArray(suggestion.buildingType)
            ? suggestion.buildingType.join(", ")
            : suggestion.buildingType
          : "",
        street: suggestion.street,
        postCode: suggestion.postCode,
        city: suggestion.city,
        country: suggestion.country ? suggestion.country : "germany",
        lat: suggestion.lat,
        long: suggestion.long,
        houseNo: suggestion.houseNo,
        isHidden: false
      };
    });
    let tp = suggestion.buildingType
      ? (_.isArray(suggestion.buildingType) && suggestion.buildingType.length > 0)
        ? suggestion.buildingType.join(", ")
        : (_.isArray(suggestion.buildingType) && suggestion.buildingType.length == 0) ? (strings.building_types) : suggestion.buildingType
      : (strings.building_types)
    setDisplayTypes(tp)
    setParamsLoaded((prev) => {
      return {
        ...prev,
        name: !!suggestion.name,
        buildingType: true,
      };
    });
    setSuggestionLoaded(true);
  };

  const getBuildings = async () => {
    try {
      const { data } = await callAPI("/building/all", "", "GET");
      if (data.status) {
        setBuildings(data.buildings);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleHideProject = async (e) => {
    if (!disableAll) {
      const newIsHidden = !params?.isHidden;
      
      if (!params?.isHidden) {
        let langText = strings.hide_project_popup_text;
        const confirmed = await $crud.confirm({
          title: "",
          textContent: langText,
          options: {
            ok: strings.confirm,
            cancel: strings.cancel
          }
        });
        if (!confirmed) return;
      }
      else {
        let langText = strings.unhidden_message;
        const confirmed = await $crud.confirm({
          title: "",
          textContent: langText,
          options: {
            ok: strings.confirm,
            cancel: strings.cancel
          }
        });
        if (!confirmed) return;
      }

      // Update local state immediately for better UX
      setParams({ ...params, isHidden: newIsHidden });

      // If editing an existing building (pid exists), update via API immediately
      if (pid) {
        try {
          const updateData = {
            id: pid,
            isHidden: newIsHidden
          };
          
          // Include other params to avoid overwriting them
          if (params.name) updateData.name = params.name;
          if (params.projectNo) updateData.projectNo = params.projectNo;
          if (params.companyId) updateData.companyId = params.companyId;
          if (params.street) updateData.street = params.street;
          if (params.postCode) updateData.postCode = params.postCode;
          if (params.city) updateData.city = params.city;
          if (params.country) updateData.country = params.country;
          if (params.lat) updateData.lat = params.lat;
          if (params.long) updateData.long = params.long;
          if (params.houseNo) updateData.houseNo = params.houseNo;
          if (params.full_address) updateData.full_address = params.full_address;
          if (params.buildingType) updateData.buildingType = params.buildingType;
          if (params.areaOfActivity) updateData.areaOfActivity = params.areaOfActivity;

          const { data } = await callAPI(`/building`, "", "POST", updateData);
          
          if (data.status) {
            // Trigger refresh of project details
            store.dispatch({
              type: UPDATE_PROJECT_ACTION_FIRE,
              updateProjectActionFire: true,
            });
          } else {
            // Revert on error
            setParams({ ...params, isHidden: !newIsHidden });
            await $crud.notify({
              type: "error",
              message: data.message || "Failed to update project visibility",
            });
          }
        } catch (error) {
          console.error("Error updating isHidden:", error);
          // Revert on error
          setParams({ ...params, isHidden: !newIsHidden });
          await $crud.notify({
            type: "error",
            message: "Failed to update project visibility",
          });
        }
      }
    }
  }

  return (
    <React.Fragment>
      <style>{`
        .add_company {
          background-color: #fff !important;
        }
        .add_company .form-bottom::-webkit-scrollbar {
          display: none;
        }
        .add_company .form-bottom {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
      <div className={`add_company add-project ${isInternal ? 'internal' : ''}`}>
        <div
          className={`add-project__header${isInternal ? ' main_heading-internal' : ''}`}
        >
          <button
            type="button"
            className={`add-project-back kj-btn kj-btn--icon kj-btn--neutral${isInternal ? ' kj-btn--internal' : ''}`}
            onClick={() => { props.closePage() }}
            aria-label="Back"
          >
            <span className={`material-symbols-outlined material-arrow-left ${isInternal ? 'internal-arrow' : ''}`}>
              keyboard_arrow_left
            </span>
          </button>
          <span className="add-project-title">
            {strings.add_or_join_project}
          </span>
        </div>
        <div className="form-bottom add-project__body">
          <Form
            className="add_company_from"
            onSubmit={(e) => {
              e.preventDefault();
              submitProject();
            }}
          >
            <Form.Group controlId="formBasicEmail">
              <AutoComplete
                suggestions={suggestions}
                setParam={setName}
                value={params.name}
                setSuggestion={getSuggestion}
                locked={paramsLoaded.name}
              />
              {errors.name && (
                <small className="pl-2 text-danger">{errors.name}</small>
              )}
            </Form.Group>
            {isInternal ?
              <Form.Group controlId="formBasicPassword">
                <Form.Control
                  value={params.projectNo}
                  onChange={(e) => setParam("projectNo", e.target.value)}
                  type="text"
                  placeholder={strings.project_No}
                  className="internal-project-input add-project__input"
                />
                {errors.projectNo && (
                  <small className="pl-2 text-danger">
                    {errors.projectNo}
                  </small>
                )}
              </Form.Group>
              :
              <></>
            }
            {!isInternal &&
              <>
                <Form.Group className="select_coustom border-0 add-project__company-group">
                  {companiesLoading ? (
                    <a
                      className="register_role text-truncate position-relative add-project__company add-project__company--loading"
                    >
                      <span className="add-project__company-label">{strings.company}* </span>
                      <div className="add-project__company-spinner" />
                    </a>
                  ) : companies.length > 1 ? (
                    <a
                      className="register_role pointer text-truncate position-relative add-project__company"
                      onClick={(e) => {
                        e.preventDefault();
                        setCompanyDialog(true);
                      }}
                    >
                      {params.companyId ? (
                        <span>{params.companyName}</span>
                      ) : (
                        <span>{strings.company}* </span>
                      )}
                      <BsChevronDown />
                    </a>
                  ) : companies.length === 1 ? (
                    <a
                      className="register_role text-truncate position-relative add-project__company add-project__company--single"
                    >
                      <span>{params.companyName || companies[0]?.name}</span>
                    </a>
                  ) : null}
                  {errors.companyId && (
                    <small className="pl-2 text-danger">
                      {errors.companyId}
                    </small>
                  )}
                </Form.Group>
                <p className="mandatory mt-0">
                  {strings.mandatory_fiels}
                </p>
                <div className="hide-room-card-header add-project__hide-card">
                  <div className="project-checkbox d-flex justify-content-between">
                    <span className="add-project__hide-label">
                      {strings.hide_project}
                    </span>
                    <ModernToggleSwitch
                      checked={params?.isHidden}
                      onChange={handleHideProject}
                      id="custom-switchx"
                      variant={isInternal ? "green" : "orange"}
                    />
                  </div>
                </div>
              </>
            }
            {
              !isInternal ?
                <div onClick={() => {
                  setShowOptionalnformation(!showOptionalInformation)
                }} className="add-project__optional-toggle">
                  <div className="kj-flex-1">
                    <h6>
                      {strings.optional_information}
                    </h6>
                  </div>
                  <div>
                    {!showOptionalInformation ?
                      <BsChevronDown
                        size={15}
                      />
                      :
                      <BsChevronUp
                        size={15}
                      />
                    }
                  </div>
                </div>
                :
                <></>
            }

            {
              !isInternal && showOptionalInformation ?
                <>
                  <Form.Group controlId="formBasicPassword11" className="add-project__address-group">
                    <LocationSearchInput
                      custom
                      defaultValue={full_address}
                      placeHolder={strings.Address}
                      setVal={setSearchCity}
                      val={searchCity}
                      setFull={(val) => {
                        setParam('full_address', val)
                        setFullAddress(val)
                      }}
                      disbled={disableAll}
                      isGerm={isGerm}
                    />
                  </Form.Group>
                  <Form.Group controlId="formBasicPassword">
                    <Form.Control
                      value={params.projectNo}
                      onChange={(e) => setParam("projectNo", e.target.value)}
                      type="text"
                      placeholder={strings.project_No}
                      className="add-project__input"
                    />
                    {errors.projectNo && (
                      <small className="pl-2 text-danger">
                        {errors.projectNo}
                      </small>
                    )}
                  </Form.Group>
                </>
                :
                <></>
            }

            <button
              className={`kj-btn kj-btn--outline${isInternal ? ' kj-btn--internal' : ''}`}
              type="submit"
            >
              {strings.add_join}
            </button>
          </Form>
        </div>

        {showCompanyDialog && (
          <CompanyListDialog
            handleClose={(e) => setCompanyDialog(false)}
            setParam={setParam}
            handleReJoinCompany={() => { }}
            companies={companies}
          />
        )}
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  const {
    projects,
    openProjects,
    updateProjectActionFire,
    openBottomProjects,
    projectRequestCount,
    isOpenByOwner,
  } = state;
  return {
    projects: projects,
    updateProjectActionFire: updateProjectActionFire,
    openProjects: openProjects,
    openBottomProjects: openBottomProjects,
    projectRequestCount: projectRequestCount,
    isOpenByOwner: isOpenByOwner,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    handleDrawer: (open) => dispatch({ type: TOGGLE_DRAWER, open })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AddProject));
